export default "__VITE_ASSET__Bock4szi__"